import React, { useState, useEffect } from "react";
import { isSubscribed, toggleSubscription } from "../utils/subscriptionsStore";
import { getSessionToken } from "../utils/auth";

// Bell toggle for subscribing to a performer. Subscribing notifies the signed-in user
// (email + optional Telegram) when that performer next appears in tomorrow's roster.
//
// Two presentations, same logic: the compact bell used in the roster tables' Notify
// column, and a wider labelled button (`showLabel`) used in the profile dialog header
// where there's room for words and no column header to explain the icon.
function NotifyButton({ venue, performerName, showLabel = false }) {
  const [subscribed, setSubscribed] = useState(() => isSubscribed(venue, performerName));
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const sync = () => setSubscribed(isSubscribed(venue, performerName));
    sync();
    window.addEventListener("subscriptions-changed", sync);
    return () => window.removeEventListener("subscriptions-changed", sync);
  }, [venue, performerName]);

  const handleClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!getSessionToken()) {
      window.dispatchEvent(new CustomEvent("open-account-panel"));
      return;
    }
    setBusy(true);
    try {
      await toggleSubscription(venue, performerName);
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      className={
        showLabel
          ? `btn btn-sm notify-btn ${subscribed ? "btn-primary" : "btn-outline-primary"}`
          : "btn btn-sm notify-btn"
      }
      onClick={handleClick}
      disabled={busy}
      title={subscribed ? "Stop notifying me" : "Notify me when available tomorrow"}
      aria-label={subscribed ? "Unsubscribe from notifications" : "Notify me when available"}
      aria-pressed={subscribed}
      style={
        showLabel
          ? { padding: "4px 12px", lineHeight: 1.4, whiteSpace: "nowrap" }
          : { padding: "2px 8px", lineHeight: 1 }
      }
    >
      {subscribed ? "🔔" : "🔕"}
      {showLabel ? <span style={{ marginLeft: 6 }}>{subscribed ? "Notifying" : "Notify me"}</span> : null}
    </button>
  );
}

export default NotifyButton;
